<!-- eslint-disable -->
<template lang="pug">
    .play-box(:class="{'with-warning': isNeedRotate, 'play-box_limited': isBattle}")
        .warning(v-if='isNeedToChangeDevice')
            svg#rotate(
                version='1.1'
                xmlns='http://www.w3.org/2000/svg'
                x='0px' y='0px' width='40px'
                height='40px' viewbox='0 0 612 612'
                style='enable-background:new 0 0 612 612;'
                xml:space='preserve'
            )
                no-phone-icon
            div
                | {{ $i18n.t('trainer.trainer_gameFormSetting_changeDevice') }}
        .warning(v-if="isNeedRotate && !isNeedToChangeDevice")
            template
                svg#rotate(
                    version='1.1',
                    xmlns='http://www.w3.org/2000/svg',
                    x='0px', y='0px', width='40px', height='40px',
                    viewBox='0 0 612 612',
                    style='enable-background:new 0 0 612 612;',
                    xml:space='preserve'
                )
                    rotation-icon
                div
                    | {{ $i18n.t('map.map_mobile_rotateText') }}
        template(v-if='!isLoading && !isNeedRotate && !isNeedToChangeDevice')
            game-header(
                v-if="!isBattle"
                v-show='(!gameFinished || (gameFinished && showPath)) &&\
                                gameStarted && !prepareForGame &&\
                                chainOfAttempts[amountOfExamples]'
                @soundStateChanged ="headerKey = !headerKey"
                :key="headerKey"
                :time="getTime"
                :slug='type'
                :game-type='parameters && parameters.courseType'
                :show-rounds="true"
                :amount-of-rounds="parameters.infinityAmountOfExamples ? -1 : parameters.numOfExamples"
                :amount-of-played-rounds="amountOfExamples"
                :is-homework="!!exerciseId"
            )
            game-preparation-counter(v-if='!isLoading && prepareForGame && !isMemoryDevelopmentCourse && !restartIsClicked' :counter="counter")
            template(v-else)
                .navigator__container_interactive-place(v-if='!prepareForGame' :class="{'navigator__container_interactive-place-battle': isBattle, 'navigator__container_interactive-position': (gameFinished && !showPath) || isNextExampleButtonShown}")
                    .navigator__main-area(v-show="!isNextExampleButtonShown && !gameFinished || isBattle" :class="{'navigator__main-area_battle': isBattle}")
                        .navigator__right-block(:class="{'navigator__right-block_is-battle': isBattle}")
                            div(v-if='(!isNextExampleButtonShown && !gameFinished) || (gameFinished && showPath)')
                                .navigator_count-of-trying(v-if='currentGoodAnswers !== 1 && AMOUNT_OF_TRIES  - currentTries')
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_youHave') }}
                                    | {{ $i18n.tc('trainer.trainer_gamePlayBox_motions',  AMOUNT_OF_TRIES - currentTries) }}
                            .navigator__buttons-container(
                                :class="{'navigator__buttons-container_battle': isBattle}"
                                v-if='!gameFinished && !isNextExampleButtonShown'
                            )
                                cs-button.navigator__button(v-if='showMemorizedButton' color="blue" @click='handleMemorized')
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_memorizedButton', { mode: $i18n.t('trainer.trainer_gamePlayBox_memorizedButton_all')}) }}
                                cs-button.navigator__button(v-if='showListenAgainButton' color="blue" @click='listenAgain')
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_listenAgainButton') }}
                                cs-button.navigator__button(v-if='showSkipStepsButton && !isOlympiad' color="blue" @click='skipSteps = true' :disabled='skipSteps')
                                    | {{ $i18n.t('trainer.trainer_gamePlayBox_skipSteps') }}
                        navigator-table(
                            v-show='gameStarted &&\
                                (!gameFinished || showPath) &&\
                                (parameters.isFieldOpened || !memorized || isAllPathShown) &&\
                                !isNextExampleButtonShown'
                            :navigator-table='navigatorTable'
                            :navigator-table-cells='navigatorTableCells'
                            :clevik-position='clevikPosition'
                            :portals='portals' :step='showingStep'
                            :interior='interior' :size='parameters.difficult'
                            :is-cells-clickable='isAllPathShown && !showPath'
                            :is-battle='isBattle'
                            @handleClick='handleClick'
                        )
                    .game-info__container(v-if="isBattle")
                        game-info(
                            :score="{left: userScore, right: opponentScore}",
                            :time="getTime",
                            :game-difficult="parameters.difficult",
                            :is-from-battle="isBattle",
                            :parameters="parameters",
                            :opponent="opponent",
                            :is-opponent-answering="isOpponentAnswering",
                        )
                    fireworks(
                        v-if='gameFinished && !isOlympiad && !isBattle &&\
                            !prepareForGame && !showPath &&\
                            amountOfExamples === parameters.numOfExamples &&\
                            goodAnswers >= 1 && parameters.infinityAmountOfExamples'
                        :is-mobile='isMobile'
                    )
                    .navigator__result-container(v-if='!isOlympiad && !isBattle')
                        result-image.navigator__result-container_image(
                            v-if='(gameFinished && !showPath) || isNextExampleButtonShown'
                            status="success"
                        )
                        .navigator__buttons-container(v-if='isNextExampleButtonShown')
                            cs-button(color="blue" @click='getExample' v-focus='')
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_playOn') }}
                        result-buttons(
                            v-else-if='gameFinished && !showPath'
                            :exercise-id="exerciseId"
                            :games-type="parameters.courseType"
                            :game-name="type"
                            show-restart-button
                            @restartGame="restartGame"
                        )
                            slot
        cs-loader(v-if="isLoading && !isNeedToChangeDevice && !isNeedRotate")
        calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
</template>
<script>
    import NavigatorTable from './NavigatorTable.vue';
    import { chunk, flatten, cloneDeep, values } from 'lodash';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import olympiadAnswerTimerMixin from '../../../../utils/olympiads/olympiadAnswerTimerMixin.js';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';
    import Battle from '../../../../utils/battle/battleMixin';
    import ResultImage from '../ResultImage.vue';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import { mapState } from 'vuex';

    const DEFAULT_VOLUME = 0.6;

    const NUMBER_INTO_DIRECTION = { 0: 'up', 1: 'down', 2: 'left', 3: 'right' };
    const NUMBER_INTO_INTERIOR = { 0: 'tree', 1: 'windmill', 2: 'pool' };
    const DIRECTIONS = ['up', 'down', 'left', 'right'];

    const AMOUNT_OF_TRIES = 3;

    function DEFAULT_DATA() {
        return {
            navigatorTable: [],
            navigatorTableCells: [],
            amountOfCells: null,
            searchCell: null,
            clevikPosition: null,
            path: [],
            clonePath: [],
            portals: [],
            amountOfExamples: 0,
            isNextExampleButtonShown: false,
            prepareForGame: true,
            memorized: false,
            currentStep: -1,
            showPath: null,
            showingStep: '',
            isAllPathShown: false,
            isRightAnswer: false,
            usedNumbers: [],
            interior: [],
            startGameInterval: null,
            showPathInterval: null,
            isListenedAgain: false,
            showSkipStepsButton: false,
            skipSteps: false,
            stopOfShowPathInterval: null,
            chainOfAttempts: [[]],
            infinityModeCompleted: false,
            isFetched: false,
            restartIsClicked: false,
        };
    }

    export default {
        mixins: [playBoxGameMixin, olympiadAnswerTimerMixin, Battle],
        props: {
            isLastGameInBattle: {
                type: Boolean,
                default: false,
            },
            battleGameParameters: {
                type: Object,
                default() {
                    return null;
                },
            },
        },
        updated() {
            !this.restartIsClicked &&
                !this.isNeedToChangeDevice &&
                !this.isFetched &&
                !this.isNeedRotate &&
                this.fetchData();
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        data() {
            return Object.assign(
                {
                    AMOUNT_OF_TRIES,
                },
                DEFAULT_DATA()
            );
        },
        watch: {
            isVerticalScreen: {
                handler(newValue) {
                    if (!newValue) {
                        this.getTableCells();
                    }
                },
            },
        },
        computed: {
            ...mapState({
                amountOfColumns(state) {
                    return (
                        ((state.trainer.game?.slug === 'Navigator' ||
                            state.trainer.game?.slug === 'NavigatorBonusGames') &&
                            state.trainer.game?.difficult) ||
                        this.battleGameParameters.parameters.default.difficult
                    );
                },
            }),
            isNeedRotate() {
                return this.isVerticalScreen && this.windowWidth <= 1024;
            },
            isNeedToChangeDevice() {
                return this.windowWidth < 768 && this.amountOfColumns > 7;
            },
            goodAnswers() {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => (count += attempt.good));
                });
                return count;
            },
            currentGoodAnswers() {
                let count = 0;
                this.chainOfAttempts[this.amountOfExamples].forEach(attempt => (count += attempt.good));
                return count;
            },
            badAnswers() {
                let count = 0;
                this.chainOfAttempts.forEach(example => {
                    example.forEach(attempt => (count += attempt.bad));
                });
                return count;
            },
            currentBadAnswers() {
                let count = 0;
                this.chainOfAttempts[this.amountOfExamples].forEach(attempt => (count += attempt.bad));
                return count;
            },
            showMemorizedButton() {
                return !this.memorized && !this.parameters.isFieldOpened;
            },
            currentTries() {
                return this.currentGoodAnswers + this.currentBadAnswers;
            },
            showListenAgainButton() {
                return (
                    !this.gameFinished &&
                    this.isAllPathShown &&
                    !this.isOlympiad &&
                    this.currentGoodAnswers !== 1 &&
                    this.currentTries < AMOUNT_OF_TRIES - 1
                );
            },
        },
        beforeDestroy() {
            clearTimeout(this.counterTimeout);
            clearTimeout(this.beforeGameStartTimeout);
            clearInterval(this.showPathInterval);
            clearInterval(this.startGameInterval);
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        methods: {
            restartGame() {
                Object.assign(this, DEFAULT_DATA());
                this.gameFinished = false;
                this.gameStarted = true;
                this.restartIsClicked = true;
                clearTimeout(this.counterTimeout);
                this.resetTimer();
                this.fetchData();
            },
            getTableCells() {
                this.$nextTick(() => {
                    let collectionOfTableCells = document.querySelectorAll('.navigator-table__press-item');
                    this.navigatorTableCells = chunk(collectionOfTableCells, this.amountOfColumns);
                });
            },
            fetchData() {
                this.getExercise()
                    .then(() => {
                        this.assignDataFromParameters();
                        this.registerSounds();
                        this.isFetched = true;

                        (this.isMemoryDevelopmentCourse ||
                            this.isMultiplicationCourse ||
                            this.restartIsClicked ||
                            !this.isNotBonusGame) &&
                            this.beforeStart();
                    })
                    .catch(() => {
                        this.isLoading = false;
                        this.$toasted.error(this.$root.$t('errors.getting_level'));
                        this.$router.push({ name: 'dashboard' });
                    });
            },
            beforeStart() {
                this.prepareForGame = false;
                this.isLoading = false;
                this.gameStarted = true;
                !this.timer && this.setTimer();
                this.parameters.isFieldOpened && this.handleMemorized();
                this.getTableCells();
            },
            startGame() {
                if (this.memorized || this.parameters.isFieldOpened) {
                    setTimeout(() => {
                        this.showNextStep();
                        this.startGameInterval = setInterval(this.showNextStep, this.parameters.speed * 1000);
                    }, 1000);
                }
            },
            showNextStep() {
                if (this.path.length !== 0) {
                    this.currentStep = this.path.shift();
                    this.$createjs.Sound.play(this.currentStep);
                } else {
                    this.currentStep = -1;
                    this.path = [];
                    this.isAllPathShown = true;
                    if (this.answerDuration) {
                        this.startAnswerTimer();
                    }
                    clearInterval(this.startGameInterval);
                    this.isOpponentAnswering = true;
                }
            },
            assignDataFromParameters() {
                this.amountOfCells = this.parameters.difficult * this.parameters.difficult;
                this.clevikPosition = this.getRandomInt(1, this.amountOfCells + 1);
                if (this.amountOfExamples !== 0) {
                    this.navigatorTableCells.forEach(row => {
                        row.forEach(cell => {
                            cell.classList.remove(
                                'navigator-table__press-item_red',
                                'navigator-table__press-item_green'
                            );
                        });
                    });
                    this.path = [];
                    this.clonePath = [];
                    this.portals = [];
                    this.interior = [];
                    this.usedNumbers = [];
                    this.currentStep = -1;
                    this.showingStep = '';
                }
                this.usedNumbers.push(this.clevikPosition);
                this.generatePortals();
                this.navigatorTable = this.generateFlyTable();
                this.generateFlyPath(this.clevikPosition);
                this.clonePath = this.path.slice(0);
                this.generateInterior();
            },
            generateFlyTable() {
                let lengthOfSide = this.parameters.difficult;
                let arrayOfNums = new Array(this.amountOfCells);
                for (let num = 0; num < this.amountOfCells; ) {
                    arrayOfNums[num] = ++num;
                }
                return chunk(arrayOfNums, lengthOfSide);
            },
            generatePortals() {
                this.portals = new Array(this.parameters.portal);
                for (let index = 0; index < this.parameters.portal; index++) {
                    this.portals[index] = [];
                }
                this.portals.forEach(portalPair => {
                    while (portalPair.length !== 2) {
                        let portalPosition = this.getRandomInt(1, this.amountOfCells + 1);
                        this.isPortalPositionValid(portalPosition) &&
                            portalPair.push(portalPosition) &&
                            this.usedNumbers.push(portalPosition);
                    }
                });
            },
            isPortalPositionValid(position) {
                return (
                    position !== this.clevikPosition &&
                    !this.portals.some(portalPair => portalPair.some(portalPosition => portalPosition === position))
                );
            },
            generateFlyPath() {
                let currPos = this.clevikPosition;
                while (this.path.length !== this.parameters.amountOfSteps) {
                    let nextStep = this.getRandomInt(0, 4);
                    if (!this.getCurrentPositionLimits(currPos).includes(NUMBER_INTO_DIRECTION[nextStep])) {
                        this.path.push(NUMBER_INTO_DIRECTION[nextStep]);
                        let nextPosition = this.getNextPositionNumber(currPos, this.path[this.path.length - 1]);
                        if (Array.isArray(nextPosition)) {
                            currPos = nextPosition.find(position => position !== nextPosition['enterPosition']);
                            this.usedNumbers.push(currPos);
                        } else if (nextPosition) {
                            currPos = nextPosition;
                            this.usedNumbers.push(currPos);
                        }
                    }
                }
                this.searchCell = currPos;
            },
            generateInterior() {
                this.usedNumbers = this.usedNumbers.filter((value, index, self) => {
                    return self.indexOf(value) === index;
                });
                this.usedNumbers.forEach(value => {
                    let limits = this.getCurrentPositionLimits(value);
                    DIRECTIONS.forEach(direction => {
                        !limits.includes(direction) &&
                            this.usedNumbers.push(this.getNextPositionNumber(value, direction));
                    });
                });
                this.usedNumbers = this.usedNumbers.filter((value, index, self) => {
                    return self.indexOf(value) === index && !Array.isArray(value);
                });
                flatten(this.navigatorTable).forEach(value => {
                    if (this.getRandomInt(0, 2) && this.getRandomInt(0, 2)) {
                        let element = NUMBER_INTO_INTERIOR[this.getRandomInt(0, 3)];
                        !this.usedNumbers.includes(value) && this.interior.push({ value, element });
                    }
                });
            },
            getNextPositionNumber(currPos, nextStep) {
                switch (nextStep) {
                    case 'up':
                        return this.getPortalPair(currPos - this.parameters.difficult)
                            ? this.getPortalPair(currPos - this.parameters.difficult)
                            : currPos - this.parameters.difficult;
                    case 'down':
                        return this.getPortalPair(currPos + this.parameters.difficult)
                            ? this.getPortalPair(currPos + this.parameters.difficult)
                            : currPos + this.parameters.difficult;
                    case 'left':
                        return this.getPortalPair(currPos - 1) ? this.getPortalPair(currPos - 1) : currPos - 1;
                    case 'right':
                        return this.getPortalPair(currPos + 1) ? this.getPortalPair(currPos + 1) : currPos + 1;
                }
            },
            getPortalPair(num) {
                return this.portals.find(portalPair => {
                    return portalPair.includes(num) && (portalPair['enterPosition'] = num);
                });
            },
            getCurrentPositionLimits(currentPosition) {
                let limits = [];
                this.navigatorTable.forEach((row, rowIndex) => {
                    row.forEach((number, columnIndex) => {
                        if (number === currentPosition) {
                            rowIndex === 0 && limits.push('up');
                            rowIndex + 1 === this.parameters.difficult && limits.push('down');
                            columnIndex === 0 && limits.push('left');
                            columnIndex + 1 === this.parameters.difficult && limits.push('right');
                        }
                    });
                });
                return limits;
            },
            getRandomInt(min, max) {
                return Math.floor(Math.random() * (max - min)) + min;
            },
            handleMemorized() {
                this.memorized = true;
                this.startGame();
            },
            handleClick(number, rowIndex, numIndex) {
                let elemOfExampleAttempts = {
                    good: 0,
                    bad: 0,
                };
                let clickedCell = this.navigatorTableCells[rowIndex][numIndex];
                this.isRightAnswer = number === this.searchCell;
                if (this.isRightAnswer) {
                    elemOfExampleAttempts.good++;
                    if (!this.isOlympiad) {
                        clickedCell.classList.add('navigator-table__press-item_green');
                        this.$createjs.Sound.play('clickCorrect');
                    }
                } else {
                    elemOfExampleAttempts.bad++;
                    if (!this.isOlympiad) {
                        clickedCell.classList.add('navigator-table__press-item_red');
                        this.$createjs.Sound.play('clickIncorrect');
                    }
                }
                this.chainOfAttempts[this.amountOfExamples].push(elemOfExampleAttempts);
                this.processReply();
            },
            processReply() {
                this.stopAnswerTimer();
                if (this.currentBadAnswers === AMOUNT_OF_TRIES || this.isRightAnswer) {
                    if (!this.isOlympiad) {
                        this.stopTimer();
                        this.showSkipStepsButton = true;
                        if (!(this.isRightAnswer && this.skipSteps)) {
                            this.showPathInterval = setInterval(this.showCorrectPath, 1500);
                            this.showPath = true;
                            this.stopOfShowPathInterval = setTimeout(() => {
                                this.handleEndOfShowingPath();
                            }, 1500 * (this.parameters.amountOfSteps + 1));
                        } else {
                            this.skipPath();
                        }
                    } else {
                        this.isOpponentAnswering = false;
                        this.amountOfExamples++;
                        this.chainOfAttempts.push([]);
                        if (this.amountOfExamples !== this.parameters.numOfExamples) {
                            this.getExample();
                        }
                        this.sendStat();
                    }
                } else {
                    this.sendStat();
                    if (this.answerDuration) {
                        this.startAnswerTimer();
                    }
                }
            },
            gameDone() {
                this.showPath = false;
                this.gameFinished = true;
                if (!this.isOlympiad && this.goodAnswers >= 1) {
                    this.soundInstance = this.$createjs.Sound.play('gameDone');
                    this.soundInstance.volume = DEFAULT_VOLUME;
                }
                this.sendStat();
            },
            getExample() {
                if (this.isNextExampleButtonShown) {
                    this.setTimer();
                    this.isNextExampleButtonShown = false;
                }
                this.memorized = false;
                this.showSkipStepsButton = false;
                this.skipSteps = false;
                this.isRightAnswer = false;
                this.showPath = null;
                this.isAllPathShown = false;
                this.currentStep = -1;
                this.assignDataFromParameters();
                this.startGame();
            },
            showCorrectPath() {
                if (!this.skipSteps) {
                    if (this.clonePath.length !== 0) {
                        this.$createjs.Sound.play('step');
                        this.showingStep = this.clonePath.shift();
                        let nextPosition = this.getNextPositionNumber(this.clevikPosition, this.showingStep);
                        if (Array.isArray(nextPosition)) {
                            this.clevikPosition = nextPosition.find(
                                position => position === nextPosition['enterPosition']
                            );
                            setTimeout(() => {
                                this.$createjs.Sound.play('portal');
                                this.clevikPosition = nextPosition.find(
                                    position => position !== nextPosition['enterPosition']
                                );
                            }, 750);
                        } else {
                            this.clevikPosition = nextPosition;
                        }
                    }
                } else {
                    this.skipPath();
                }
            },
            handleEndOfShowingPath() {
                clearInterval(this.showPathInterval);
                this.$nextTick(() => {
                    this.amountOfExamples++;
                    this.chainOfAttempts.push([]);
                    if (this.amountOfExamples === this.parameters.numOfExamples) {
                        if (this.isBattle) {
                            this.stopTimer();
                            this.gameDone();
                            return;
                        }
                        this.gameDone();
                    } else {
                        this.stopTimer();
                        this.isNextExampleButtonShown = true;
                        if (this.isBattle) {
                            setTimeout(() => {
                                this.getExample();
                            }, 1000);
                        }
                    }
                    this.sendStat();
                });
            },
            skipPath() {
                this.$createjs.Sound.play('step');
                clearTimeout(this.stopOfShowPathInterval);
                setTimeout(() => {
                    this.handleEndOfShowingPath();
                }, 1400);
                this.clevikPosition = this.searchCell;
                this.clonePath = [];
            },
            refreshGameStatBeforeSend() {
                this.gameStat.chainOfAttempts = this.chainOfAttempts;
                this.gameStat.attempts =
                    this.currentBadAnswers === AMOUNT_OF_TRIES || this.isRightAnswer
                        ? this.chainOfAttempts[this.amountOfExamples - 1].length
                        : this.chainOfAttempts[this.amountOfExamples].length;
                this.gameStat.answers = this.amountOfExamples;
                this.gameStat.percent = this.calculatePercent();
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time !== 0 ? this.time : this.timeBeforeDestroy;
                this.gameStat.isCorrect = this.isRightAnswer;
                this.gameStat.parameters = cloneDeep(this.parameters);
                if (this.parameters.infinityAmountOfExamples) {
                    this.gameStat.parameters.numOfExamples = this.amountOfExamples;
                }
                this.gameStat.infinityAmountOfExamples = this.parameters.infinityAmountOfExamples;
                this.gameStat.infinityModeCompleted = this.infinityModeCompleted;
            },
            calculatePercent() {
                let total = this.goodAnswers + this.badAnswers;
                if (total > 0) {
                    return parseInt((this.goodAnswers / total) * 100);
                }
                return 0;
            },
            listenAgain() {
                let elemOfExampleAttempts = {
                    good: 0,
                    bad: 1,
                };
                this.chainOfAttempts[this.amountOfExamples].push(elemOfExampleAttempts);
                this.isAllPathShown = false;
                this.path = values(this.clonePath);
                this.processReply();
                this.startGame();
            },
            beforeGameRestart() {
                Object.assign(this, DEFAULT_DATA());
            },
            beforeTabClosed() {
                if (this.isBattle) {
                    this.sendStat();
                    return;
                }
                if (this.gameStarted && this.user.type === 'student') {
                    this.gameFinished = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
                return null;
            },
        },
        components: {
            NavigatorTable,
            GamePreparationCounter,
            ResultImage,
            CalculatingAnswers,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';

    .navigator__container_interactive-place {
        display: flex;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        overflow: hidden;
        flex: 1 1 auto;
        left: 0;
        width: 100%;
        height: 100%;
        @include media($lg) {
            height: 80%;
            position: absolute;
        }
        &-battle {
            height: 100%;
            left: -50px;
        }
    }

    .navigator__container_interactive-position {
        position: relative;
    }

    .navigator__main-area {
        text-align: center;
        overflow: hidden;
        display: flex;
        flex-direction: row-reverse;
        justify-content: center;
        align-items: center;
        @include media($lg) {
            flex: 1 1 auto;
        }
    }

    .navigator__main-area_battle {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        @include media($xxl) {
            display: flex;
            flex-direction: row-reverse;
            justify-content: center;
        }
    }

    .game-info__container {
        margin-left: 30px;
    }

    .navigator__right-block {
        margin: 15px;
        @include media($xlg) {
            margin: 30px;
        }
    }

    .navigator__right-block_is-battle {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @include media($lg) {
            flex-direction: row;
        }
        @include media($xxl) {
            width: auto;
        }
    }

    .navigator_count-of-trying {
        font-size: 18px;
    }

    .navigator__buttons-container {
        display: flex;
        justify-content: center;
        text-align: center;
        margin-top: 20px;
    }

    .navigator__buttons-container_battle {
        margin-top: 20px;
        @include media($lg) {
            margin: 0 0 0 20px;
        }
    }

    .navigator__link {
        @media screen and (max-width: 640px) {
            display: block;
            width: 100%;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .navigator__button {
        width: 130px;
        height: 55px;
        font-size: 12px;
        @include media($md) {
            width: 160px;
            height: 60px;
            font-size: 14px;
        }
        @include media($xlg) {
            width: 100%;
            font-size: 18px;
            height: 100%;
        }
    }

    .navigator__result-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .navigator__result-container_image {
        @include stack-space($space-base);
        max-width: 450px;
        max-height: 420px;
        vertical-align: middle;
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .with-warning {
        display: table;
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }
</style>
